import { render, staticRenderFns } from "./PlayList.vue?vue&type=template&id=5c57bbd4&scoped=true&"
import script from "./PlayList.vue?vue&type=script&lang=js&"
export * from "./PlayList.vue?vue&type=script&lang=js&"
import style0 from "./PlayList.vue?vue&type=style&index=0&id=5c57bbd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57bbd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c57bbd4')) {
      api.createRecord('5c57bbd4', component.options)
    } else {
      api.reload('5c57bbd4', component.options)
    }
    module.hot.accept("./PlayList.vue?vue&type=template&id=5c57bbd4&scoped=true&", function () {
      api.rerender('5c57bbd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/music/comp/PlayList.vue"
export default component.exports